<ng-container *ngrxLet="authStore.isDemo$ as isDemo">
  <div class="flex xs:flex-col flex-row flex-wrap gap-[24px] justify-start items-center">
    <!-- heating.configuration.heatingRod.heating -->
    <ng-container *ngIf="heatingRodHeating$ | async | ready as feature">
      <!-- setHeatingApproved -->
      <div
        class="flex flex-row gap-[5px] xs:justify-between justify-start xs:w-full w-auto items-center"
      >
        <div>
          {{ '+INSTALLATIONS.INSTALLATION.ELECTRIC_HEATER.HEATING_CIRCUITS.LABEL' | translate }}
        </div>
        <mat-slide-toggle
          data-at-toggle-heating-rod-heating
          gtm="onToggle"
          gtmAction="Electric Heater Heating Circuits"
          gtmCategory="electricHeater"
          matTooltip="{{
            '+INSTALLATIONS.INSTALLATION.ELECTRIC_HEATER.HEATING_CIRCUITS.ACTIVATION.SLIDE_TOGGLE_TOOLTIP'
              | translate
          }}"
          [disabled]="isDemo ? false : !(feature | executable: featureCommands.setHeatingApproved)"
          [checked]="feature?.properties?.heatingApproved?.value"
          (click)="onHeatingRodHeatingChange(!feature.properties?.heatingApproved?.value)"
        ></mat-slide-toggle>
      </div>

      <!-- setDhwApproved -->
      <div
        class="flex flex-row gap-[5px] xs:justify-between justify-start xs:w-full w-auto items-center"
      >
        <div>{{ '+INSTALLATIONS.INSTALLATION.ELECTRIC_HEATER.DHW.LABEL' | translate }}</div>
        <mat-slide-toggle
          data-at-toggle-heating-rod-dhw
          gtm="onToggle"
          gtmAction="Electric Heater DHW"
          gtmCategory="electricHeater"
          matTooltip="{{
            '+INSTALLATIONS.INSTALLATION.ELECTRIC_HEATER.DHV.ACTIVATION.SLIDE_TOGGLE_TOOLTIP'
              | translate
          }}"
          [disabled]="isDemo ? false : !(feature | executable: featureCommands.setDhwApproved)"
          [checked]="feature.properties?.dhwApproved?.value"
          (click)="onHeatingRodDhwChange(!feature.properties?.dhwApproved?.value)"
        ></mat-slide-toggle>
      </div>
    </ng-container>
    <!-- heating.configuration.dhwHeater -->
    <div
      *ngIf="heatingConfigurationDhwHeater$ | async | ready as feature"
      class="flex flex-row gap-[5px] xs:justify-between justify-start xs:w-full w-auto items-center"
    >
      <div>
        {{
          '+INSTALLATIONS.INSTALLATION.ELECTRIC_HEATER.SEPARATE_HEATING_ROD_DHW.LABEL' | translate
        }}
      </div>
      <mat-slide-toggle
        data-at-toggle-heating-configuration-dhwHeater
        gtm="onToggle"
        gtmAction="Heating Configuration Dhw Heater"
        gtmCategory="electricHeater"
        matTooltip="{{
          '+INSTALLATIONS.INSTALLATION.ELECTRIC_HEATER.SEPARATE_HEATING_ROD_DHW.SLIDE_TOGGLE_TOOLTIP'
            | translate
        }}"
        [disabled]="
          isDemo
            ? false
            : feature.properties?.useApproved?.value
            ? (feature | executable: featureCommands.grant)
            : (feature | executable: featureCommands.revoke)
        "
        [checked]="feature.properties?.useApproved?.value"
        (click)="onHeatingConfigurationDhwHeaterChange(!feature.properties?.useApproved?.value)"
      ></mat-slide-toggle>
    </div>
  </div>

  <app-feature-details-grid>
    <app-feature-list-container>
      <!-- heatingRods.heatGeneration.N.status -->
      <app-feature-list-item
        *ngIf="heatingRodStatus$ | async | ready as feature"
        data-at-heating-rod-status
        [label]="'+INSTALLATIONS.INSTALLATION.ELECTRIC_HEATER.STATUS.LABEL' | translate"
        [value]="getHeatingRodStatusValue(feature) | translate"
        [attr.data-feature]="feature.feature"
      >
      </app-feature-list-item>

      <!-- heating.heatingRod.statistics -->
      <ng-container *ngIf="heatingRodStatistics$ | async | ready as feature">
        <!-- heating.heatingRod.statistics/hours -->
        <app-feature-list-item
          data-at-heating-rod-statistics-feature-hours
          label="{{ '+INSTALLATIONS.INSTALLATION.ELECTRIC_HEATER.STATISTICS.LABEL' | translate }}"
          value="{{ feature | value2: featurePropertyKey.hours | toFixed: 0 }} {{
            feature | unit: featurePropertyKey.hours
          }}"
          [attr.data-feature]="feature.feature + '/hours'"
          [error]="feature | error"
        >
        </app-feature-list-item>

        <!-- heating.heatingRod.statistics/starts -->
        <app-feature-list-item
          data-at-heating-rod-statistics-feature-starts
          label="{{
            '+INSTALLATIONS.INSTALLATION.ELECTRIC_HEATER.STATISTICS.STARTS_LABEL' | translate
          }}"
          value="{{ feature | value2: featurePropertyKey.starts }}"
          [attr.data-feature]="feature.feature + '/starts'"
          [error]="feature | error"
        >
        </app-feature-list-item>
      </ng-container>

      <!-- heating.heatingrod.maximumOutsideTemperature -->
      <app-feature-list-item
        *ngIf="heatingRodMaximumOutsideTemperature$ | async | ready as feature"
        data-at-heating-rod-maximum-outside-temperature-feature
        label="{{
          '+INSTALLATIONS.INSTALLATION.ELECTRIC_HEATER.MAXIMUM_OUTSIDE_TEMPERATURE.LABEL'
            | translate
        }}"
        value="{{ feature | value2: featurePropertyKey.value }} {{
          feature | unit: featurePropertyKey.value
        }}"
        [attr.data-feature]="feature.feature"
        [error]="feature | error"
      >
      </app-feature-list-item>
    </app-feature-list-container>
  </app-feature-details-grid>

  <!-- heating.configuration.secondaryHeatGenerator.modeOnError -->
  <app-feature-details-grid>
    <app-feature-list-container class="actions-container">
      <div
        *ngIf="heatingConfigurationSecondaryHeatGeneratorModeOnError$ | async | ready as feature"
        class="flex flex-row justify-between"
      >
        <div class="max-w-[300px]">
          {{ '+INSTALLATIONS.INSTALLATION.ELECTRIC_HEATER.CODING_701C.LABEL' | translate }}
          <mat-icon
            [matTooltip]="
              '+INSTALLATIONS.INSTALLATION.ELECTRIC_HEATER.CODING_701C.TOOLTIP' | translate
            "
            matTooltipClass="multiline-tooltip"
            >info</mat-icon
          >
        </div>
        <mat-slide-toggle
          data-at-heating-configuration-secondary-heat-generator-mode-on-error
          gtm="onToggle"
          gtmAction="Heating Configuration Secondary Heat Generator Mode On Error "
          gtmCategory="electricHeater"
          [disabled]="isDemo ? false : !(feature | executable: featureCommands.setMode)"
          [checked]="
            feature.properties?.mode?.value ===
            heatingConfigurationSecondaryHeatGeneratorModeOnErrorValue.normal
          "
          (change)="onHeatingConfigurationSecondaryHeatGeneratorModeOnErrorChange($event)"
        ></mat-slide-toggle>
      </div>
    </app-feature-list-container>
  </app-feature-details-grid>
</ng-container>
